import { render, staticRenderFns } from "./SkuTree.vue?vue&type=template&id=0122d3c2&"
import script from "./SkuTree.vue?vue&type=script&lang=js&"
export * from "./SkuTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports